import AddressTypes from 'common/Forms/AddressTypes';
import {
  GetFieldPathValueMap as GetFatcaCrsFieldPathValueMap,
  GetWellFormedAddress as GetFatcaCrsWellFormedAddress
} from 'common/Addresses/AddressFormatters/CombinedFormAddressFormatter/CommonCombinedFormAddressFormatter';

function GetControllingPersonFieldPathValueMap(addressPath, wellFormedAddress) {
  const fieldPathValueDictionary = [
    { key: `${ addressPath }.line1`, value: wellFormedAddress?.addressLine1 },
    { key: `${ addressPath }.line2`, value: wellFormedAddress?.addressLine2 },
    { key: `${ addressPath }.line3`, value: wellFormedAddress?.addressLine3 },
    { key: `${ addressPath }.line4`, value: wellFormedAddress?.addressLine4 },
    { key: `${ addressPath }.postalCode`, value: wellFormedAddress?.addressPostalCode },
    { key: `${ addressPath }.country`, value: wellFormedAddress?.addressCountry }
  ];

  return fieldPathValueDictionary;
}

function GetControllingPersonWellFormedAddress(formAddress) {
  const wellFormedAddress = {
    line1: formAddress?.line1 ?? '',
    line2: formAddress?.line2 ?? '',
    line3: formAddress?.line3 ?? '',
    line4: formAddress?.line4 ?? '',
    postalCode: formAddress?.postalCode ?? '',
    country: formAddress?.country ?? ''
  };

  return wellFormedAddress;
}

export function GetFieldPathValueMap(addressProps, wellFormedAddress) {
  switch (addressProps?.addressType) {
    case AddressTypes.Permanent:
    case AddressTypes.Mailing:
      return GetFatcaCrsFieldPathValueMap(addressProps, wellFormedAddress);
    case AddressTypes.ControllingPersonPermanent:
      return GetControllingPersonFieldPathValueMap(`part5.controllingPersons[${ addressProps?.controllingPersonIndex }].residenceAddress`, wellFormedAddress);
    case AddressTypes.ControllingPersonMailing:
      return GetControllingPersonFieldPathValueMap(`part5.controllingPersons[${ addressProps?.controllingPersonIndex }].mailingAddress`, wellFormedAddress);
    default:
      break;
  }
}

export function GetWellFormedAddress(addressProps, addressValues) {
  switch (addressProps?.addressType) {
    case AddressTypes.Permanent:
    case AddressTypes.Mailing:
      return GetFatcaCrsWellFormedAddress(addressProps, addressValues);
    case AddressTypes.ControllingPersonPermanent:
      return GetControllingPersonWellFormedAddress(addressValues?.part5?.controllingPersons
        && addressValues.part5.controllingPersons[addressProps?.controllingPersonIndex]?.residenceAddress);
    case AddressTypes.ControllingPersonMailing:
      return GetControllingPersonWellFormedAddress(addressValues?.part5?.controllingPersons
        && addressValues.part5.controllingPersons[addressProps?.controllingPersonIndex]?.mailingAddress);
    default:
      break;
  }
}
